import { Route, Routes } from "react-router-dom";

import { Layout } from "@/components/Layout";
import { HomePage } from "@/pages/HomePage";
import { CalendarPage } from "@/pages/CalendarPage";
import { RoomPage } from "@/pages/RoomPage";
import { BookingFormPage } from "@/pages/BookingFormPage";
import { CancelPage } from "@/pages/CancelPage";
import { LoginPage } from "@/pages/LoginPage";
import { MyBookingsPage } from "@/pages/MyBookingsPage";
import { NotFoundPage } from "@/pages/NotFoundPage";
import { PaymentStatusPage } from "@/pages/PaymentStatusPage";
import { ProfilePage } from "@/pages/ProfilePage";
import { RegisterPage } from "@/pages/RegisterPage";
import { ServerErrorPage } from "@/pages/ServerErrorPage";
import { VerifyPage } from "@/pages/VerifyPage";

export default function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/kalender" element={<CalendarPage />} />
        <Route path="/raum/:slug" element={<RoomPage />} />
        <Route path="/buchen/:slug" element={<BookingFormPage />} />
        <Route path="/stornieren" element={<CancelPage />} />
        <Route path="/bezahlung" element={<PaymentStatusPage />} />
        <Route path="/konto/registrieren" element={<RegisterPage />} />
        <Route path="/konto/verify" element={<VerifyPage />} />
        <Route path="/konto/login" element={<LoginPage />} />
        <Route path="/konto/buchungen" element={<MyBookingsPage />} />
        <Route path="/konto/profil" element={<ProfilePage />} />
        <Route path="/fehler" element={<ServerErrorPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}
